import { useNavigate } from 'react-router-dom';
import {
    useGetAllDepreciationMethodTypesQuery,
    useUpdateListDepreciationMethodTypesMutation,
} from '../../../services/fixedAssets/fixedAssets.service';
import { PermissionsUtil } from '../../../utils/permissions/permissionsUtil';
import { PERMISSIONS } from '../../../constants/permissions/Permissions.constants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { RoutingValues } from '../../../types/Shared.types';
import { FA_DepreciationMethodType } from '../../../types/FixedAsset.types';
import { useEffect } from 'react';
import _ from 'lodash';
import { getMaxSortOrderValue } from '../../../store/fixedAssets';

const UseFixedAssetDepreciationMethodTypeGrid = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const { data: typeList, isLoading: isLoadingTypes } =
        useGetAllDepreciationMethodTypesQuery();

    const [updateDepreciationMethodTypes] =
        useUpdateListDepreciationMethodTypesMutation();

    const canCreateDepreciationMethodType = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.FIXED_ASSETS.DEPRECIATION_METHOD_TYPES.CREATE
    );
    const canViewDepreciationMethodType = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.FIXED_ASSETS.DEPRECIATION_METHOD_TYPES.VIEW
    );

    const handleGridEdits = (editedRows: FA_DepreciationMethodType[]) => {
        updateDepreciationMethodTypes(editedRows);
    };

    const redirectToForm = (row: any) => {
        if (row.id) {
            navigate(
                `/accounting/fixedAssets/depreciationMethodType/${row.id}/${RoutingValues.update}`
            );
        } else {
            navigate(
                `/accounting/fixedAssets/depreciationMethodType/${RoutingValues.newId}/${RoutingValues.create}`
            );
        }
    };

    useEffect(() => {
        let maxValue = 1;
        if (typeList && typeList.length > 0) {
            const data = _.maxBy(
                typeList,
                (depreciationType: FA_DepreciationMethodType) =>
                    depreciationType.sortOrder
            );
            maxValue = data.sortOrder + 1;
        }
        dispatch(
            getMaxSortOrderValue({ isLoading: false, maxValue: maxValue })
        );
    }, typeList);

    return {
        typeList,
        redirectToForm,
        isLoadingTypes,
        canCreateDepreciationMethodType,
        canViewDepreciationMethodType,
        handleGridEdits,
    };
};

export default UseFixedAssetDepreciationMethodTypeGrid;
